import { Grid, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography, useMediaQuery } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetCodTransactionsByIdQuery, useLazyGetCodTransactionsOrdersXlsQuery } from 'src/_api/mapitShipInvoice'
import { DownloadExcelDialog } from 'src/_modules/common'
import DataTable from 'src/components/common/DataTables/DataTable'

const $COLUMN_WIDTH = 200;
export default function CodTransactionOrdersDialog({
    open,
    onClose,
    transactionId
}) {

    const { t } = useTranslation()

    const [page, setPage] = useState(1)

    const {
        data: orders,
        isLoading: ordersLoading,
        isFetching: ordersFetching,
    } = useGetCodTransactionsByIdQuery({ transactionId, payload: { page } }, { skip: !transactionId })

    const pageChangeHandler = (page) => {
        if (ordersLoading || ordersFetching) return
        setPage(page)
    }

    const [rowCount, setRowCount] = useState(0)

    useEffect(() => {
        if (!!orders) return setRowCount(orders?.completedOrders?.totalDocs)
    }, [orders])

    const columns = [
        { field: "orderNumber", sortable: false, headerName: t("Order Number"), width: $COLUMN_WIDTH * 1.3 },
        { field: "otoIntegration", valueGetter: ({ value }) => value?.shipment?.trackingNumber, sortable: false, headerName: t("Tracking Number"), width: $COLUMN_WIDTH * 1.3 },
        { field: "shippingComapny", valueGetter: ({ row }) => row?.otoIntegration?.shipment?.deliveryOption?.deliveryOptionName, sortable: false, headerName: t("Shipping Company"), width: $COLUMN_WIDTH * 1.3 },
        { field: "amountPayable", valueGetter: ({ value }) => value ? value?.toFixed(2) : '-', sortable: false, headerName: t("Amount Payable"), width: $COLUMN_WIDTH * 0.8, },
        {
            field: "deliveredAt",
            headerName: t("Delivery Date"),
            width: $COLUMN_WIDTH * 0.7,
            valueGetter: ({ value }) => value ? moment(value).format("DD/MM/YY - h:mm A") : '', align: 'center'
        }
    ]

    //======= Export ExcelFile =======

    const [getCodTransactionsOrdersXlsQuery, { isLoading: excelLoading }] = useLazyGetCodTransactionsOrdersXlsQuery()

    //===================Excel download====================
    const [openExcelDialog, setOpenExcelDialog] = useState(false)
    const [excelIsSuccess, setExcelIsSuccess] = useState(false)
    const [excelError, setExcelError] = useState(null)


    const onCloseExcelDialogHandler = () => {
        setOpenExcelDialog(false)
        setExcelIsSuccess(false)
        setExcelError(null)
    }

    const onSendHandler = async ({ email }) => {
        try {
            setExcelIsSuccess(false)
            setExcelError(null)

            getCodTransactionsOrdersXlsQuery({ codTransactionId: transactionId, params: { email } }).unwrap()

            setExcelIsSuccess(true)
            setTimeout(() => {
                onCloseExcelDialogHandler()
            }, 2000);

        } catch (error) {
            console.log(error)
            setExcelError(error)
        }
    }

    const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

    return (
        <>
            <DownloadExcelDialog
                open={openExcelDialog}
                onSend={onSendHandler}
                rowCount={rowCount}
                onClose={onCloseExcelDialogHandler}
                loading={excelLoading}
                isSuccess={excelIsSuccess}
                error={excelError}
                options={["EMAIL"]}
            />
            <Dialog
                open={open}
                onClose={e => e.preventDefault()}
                maxWidth="lg"
                fullWidth
                fullScreen={fullScreen}
            >
                <DialogTitle>{t("Orders")}</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid item xs={12} sm={6} md={4}>
                            <Stack>
                                <Typography variant='body2' fontWeight='bold' color="text.lighter">
                                    {t("Start Date")}
                                </Typography>
                                <Typography variant='body2' fontWeight='bold'>
                                    {orders?.startDate ? moment(orders?.startDate).format("DD/MM/YY - h:mm A") : ''}
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Stack>
                                <Typography variant='body2' fontWeight='bold' color="text.lighter">
                                    {t("End Date")}
                                </Typography>
                                <Typography variant='body2' fontWeight='bold'>
                                    {orders?.endDate ? moment(orders?.endDate).format("DD/MM/YY - h:mm A") : ''}
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Stack>
                                <Typography variant='body2' fontWeight='bold' color="text.lighter">
                                    {t("Total incoming payments")}
                                </Typography>
                                <Typography variant='body2' fontWeight='bold'>
                                    {!!orders?.codAmount ? orders?.codAmount.toFixed(2) : '-'}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Box display="flex" flex={1} justifyContent="flex-end">
                        <Button
                            onClick={() => setOpenExcelDialog(true)}
                            variant='contained'
                            color='success'
                            sx={{ textTransform: 'none' }}
                        >
                            {t("Excel")}
                        </Button>
                    </Box>
                    <Box sx={{ height: "75vh", mt: 2 }}>
                        <DataTable
                            tableId="DATA-TABLE-TRANSACTION-ORDERS"
                            rows={orders?.completedOrders?.docs ?? []}
                            columns={columns}
                            loading={ordersLoading || ordersFetching}
                            rowCount={rowCount}
                            page={page}
                            pageSize={20}
                            onRowClick={() => { }}
                            onPageChange={pageChangeHandler}
                            checkboxSelection={false}
                            customComponents={["Pagination"]}
                        />
                    </Box>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Box mr="auto" />
                    <Button
                        onClick={onClose}
                        variant='contained'
                        sx={{ textTransform: 'none' }}
                    >
                        {t("Close")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
